import {apiClient} from '../../../../lib/api-client';
import {ChangeOrderProductSearchResult} from "../types/ChangeOrderProductSearchResult"

export async function apiSearchChangeOrderProducts(pricingDate: Date, dealerCompanyID: number, productLineID: number, zipCode: string,
    productTypeID?: number, sku?: string, description?: string): Promise<ChangeOrderProductSearchResult> {
    try {
        return {
            isSuccess: true,
            products: await apiClient.get("product/change-order-search",
                {
                    params: {
                        pricingDate: pricingDate,
                        dealerCompanyID: dealerCompanyID,
                        productLineID: productLineID,
                        productTypeID: productTypeID,
                        sku: sku,
                        description: description,
                        zipCode: zipCode,
                    }
                }),
        }

    }
    catch (error: any) {
        return {
            isSuccess: false,
            errorMessage: error,
            products: []
        };
    }
};
